module.exports = __webpack_public_path__ + "static/media/icons8-cancel.738c8b75.svg";